import React, { Component } from "react";
import {
  Button,
  Chip,
  Dialog,
  DialogTitle,
  Grid, IconButton,
  List,
  ListItem,
  ListItemText,
  Snackbar,
  Tooltip,
  Typography
} from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import { Close, LocalOffer } from "@mui/icons-material";
import "./productCard.css";
import { Product, ProductOption } from "../../../classes/types/product/product";
import { CartHandler } from "../../../classes/methods/cartMethods/cartMethods";
import standardImage from "../../../assets/defaultImage.jpg";
import { CartItem } from "../../../classes/types/cart/cart";
import { euroPrint } from "../../../classes/types/currencysettings";
import { Alert } from "@mui/lab";
import AddToCartSmallBtn from "../addToCartSmallBtn/addToCartSmallBtn";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDolly } from "@fortawesome/free-solid-svg-icons";
import dayjs from "dayjs";
import MoneyOffIcon from "@mui/icons-material/MoneyOff";
import BuildIcon from '@mui/icons-material/Build';

interface props {
  product: Product;
  loading: boolean;
  linkName: string;
  isLogged: boolean;
}

interface state {
  openSnackBar: boolean;
  productOptions: Array<ProductOption>;
  loading: boolean;
  productsError: Array<any>;
  errorDialog: boolean;
}

export default class ProductCard extends Component<props, state> {
  constructor(props: props) {
    super(props);
    this.state = {
      openSnackBar: false,
      productOptions: new Array<ProductOption>(),
      loading: this.props.loading,
      productsError: new Array<any>(),
      errorDialog: false,
    };
  }

  componentDidMount() {
    /* ProductHandler.getProductOptions(this.props.product.id).then((newProductOptions) => {
          this.setState({
              productOptions: newProductOptions,
          })
        }).catch(() => {

        })*/
  }

  render() {
    return (
      <div style={{ width: "100%" }}>
        <div style={{ height: "100%" }}>
          <Grid container>
            <Grid
              style={{ overflow: "hidden", maxWidth: "100%", height: "180px" }}
              direction={"column"}
              xs={2}
              justifyContent={"center"}
              alignContent={"center"}
              item
              container
            >
              <Link to={this.props.linkName}>
                <div
                  style={{
                    padding: "5%",
                    overflow: "hidden",
                    cursor: "pointer",
                  }}
                >
                  <img
                    style={{
                      cursor: "pointer",
                      height: "100%",
                      width: "100%",
                      objectFit: "contain",
                    }}
                    alt={"ciao"}
                    src={this.props.product.images.length > 0 ? this.props.product.images[0].link : standardImage}
                  />
                </div>
              </Link>
            </Grid>
            <Grid
              alignContent={"flex-start"}
              direction={"column"}
              xs={7}
              item
              container
            >
              <Link to={this.props.linkName}>
                <Typography
                  variant="subtitle1"
                  style={{
                    marginTop: "10px",
                    textAlign: "left",
                    cursor: "pointer",
                  }}
                  component="h2"
                >
                  <div style={{ cursor: "pointer" }}>
                    <b>{this.props.product.name}</b>
                  </div>
                </Typography>
                <Typography
                  style={{ textAlign: "left", cursor: "pointer" }}
                  variant="subtitle2"
                  component="h2"
                >
                  <i>Codice: {this.props.product.sku}</i>
                </Typography>
                <div
                  style={{
                    textAlign: "left",
                    marginTop: "auto",
                    marginBottom: "10px",
                    cursor: "pointer",
                  }}
                >
                  <br />
                  {this.props.product.maker !== "" ? (
                    <Chip
                      size="small"
                      icon={<LocalOffer />}
                      color="primary"
                      style={{
                        marginRight: "5px",
                        marginTop: "5px",
                        paddingLeft: "10px",
                        paddingRight: "10px",
                      }}
                      label={this.props.product.maker}
                    />
                  ) : (
                    ""
                  )}
                  {this.props.product.arrivingQuantity > 0 && this.props.isLogged ? (
                    <Chip
                      size="small"
                      icon={<FontAwesomeIcon icon={faDolly} />}
                      style={{
                        marginRight: "5px",
                        marginTop: "5px",
                        paddingLeft: "10px",
                        paddingRight: "10px",
                      }}
                      label={"In arrivo " +
                        this.props.product.arrivingQuantity +
                        (this.props.product.arrivingQuantityDate !== "" ? dayjs(this.props.product.arrivingQuantityDate, "YYYY-MM-DD").isSame(dayjs()) || dayjs(this.props.product.arrivingQuantityDate, "YYYY-MM-DD").isBefore(dayjs()) ? " durante la giornata odierna" : " dal " + dayjs(this.props.product.arrivingQuantityDate, "YYYY-MM-DD").format("DD/MM/YYYY") : "")}
                    />
                  ) : (
                    ""
                  )}
                  {this.props.product.status.toLowerCase() === 'in esaurimento' ? <Chip
                    size="small"
                    icon={<MoneyOffIcon style={{ color: "white" }} />}
                    style={{
                      marginRight: "5px",
                      marginTop: "5px",
                      paddingLeft: "10px",
                      paddingRight: "10px",
                      backgroundColor: "green",
                      color: "white"
                    }}
                    label={"In Promozione"}
                  /> : ""}
                </div>
              </Link>
            </Grid>
            <Grid direction={"column"} xs={3} item container>
              {this.props.product.configurable ?
                <Typography
                  variant="subtitle1"
                  style={{
                    fontSize: "1.2rem",
                    marginTop: "10px",
                    textAlign: "right",
                    marginRight: "2%",
                  }}
                  component="h1"
                >
                  Configura per visualizzare il prezzo
                </Typography> : !this.props.isLogged ? (
                  <Typography
                    variant="subtitle1"
                    style={{
                      fontSize: "1.2rem",
                      marginTop: "10px",
                      textAlign: "right",
                      marginRight: "2%",
                    }}
                    component="h1"
                  >
                    Accedi per visualizzare il prezzo
                  </Typography>
                ) : (
                  <Typography
                    variant="subtitle1"
                    style={{
                      fontSize: "1.5rem",
                      marginTop: "10px",
                      textAlign: "right",
                      marginRight: "2%",
                    }}
                    component="h1"
                  >
                    <Link to={this.props.linkName}>
                      <b style={{ whiteSpace: "nowrap" }}>
                        <span
                          style={{
                            textDecoration:
                              this.props.product.discountedPrice !== undefined
                                ? "line-through"
                                : "",
                          }}
                        >
                          {euroPrint(this.props.product.price)}
                        </span>
                        <b>
                          <span
                            style={{ color: "#b3071b", marginLeft: "10px" }}
                            hidden={
                              this.props.product.discountedPrice === undefined
                            }
                          >
                            {euroPrint(this.props.product.discountedPrice)}
                          </span>
                        </b>
                      </b>
                      {this.props.product.discountedPrice !== undefined ? (
                        <Typography variant="subtitle2">
                          <b>
                            Risparmi il{" "}
                            <span
                              style={{
                                padding: "1%",
                                backgroundColor: "#b3071b",
                                color: "white",
                              }}
                            >
                              {Math.round(
                                ((this.props.product.price -
                                  this.props.product.discountedPrice) /
                                  this.props.product.price) *
                                100
                              )}
                              %
                            </span>{" "}
                            sul prezzo di listino
                          </b>
                        </Typography>
                      ) : (
                        ""
                      )}
                    </Link>
                  </Typography>
                )}
              <div
                hidden={this.state.productOptions.length <= 0}
                style={{
                  marginTop: "auto",
                  textAlign: "right",
                  marginBottom: "10px",
                  marginRight: "2%",
                }}
              >
                <Link to={this.props.linkName}>
                  <Button className={"button-position"} variant={"outlined"}>
                    Configura
                  </Button>
                </Link>
                <Button
                  variant={"contained"}
                  disabled={this.props.product.stock1 < 1}
                  color="primary"
                  onClick={this.addToCart}
                >
                  Aggiungi al carrello
                </Button>
              </div>
              <div
                style={{
                  marginBottom: "10px",
                  marginTop: "auto",
                  textAlign: "right",
                  marginRight: "2%",
                }}
                hidden={!(this.state.productOptions.length < 1)}
              >
                {!this.props.product.configurable && this.props.isLogged ? <div>
                  {this.props.product.stock1 > 0 ? (
                    <span style={{ color: "green" }}>
                      Disponibili in magazzino:{" "}
                      <b>{this.props.product.stock1} pezzi</b>
                    </span>
                  ) : (
                    <span style={{ color: "red" }}>Non Disponibile</span>
                  )}
                </div> : ""}
                {this.props.product.stock1 === 0 && this.props.product.arrivingQuantity === 0 ?
                  <Typography
                    variant="subtitle2"
                    style={{
                      color: "red",
                    }}
                  >
                    Da ordinare.
                    <Tooltip title="Contatta il commerciale per chiedere i tempi di consegna della merce contrassegnata da ‘ordinare">
                      <InfoIcon
                        fontSize="medium"
                        style={{
                          cursor: "pointer",
                          color: "#990617",
                          verticalAlign: "middle", // 🔥 allineamento
                          marginLeft: 4,
                        }}
                      />
                    </Tooltip>
                  </Typography> :
                  // this.props.product.arrivingQuantity > 0 && (1 > this.props.product.stock1) && (1 <= this.props.product.arrivingQuantity + this.props.product.stock1) ?
                  //   <Typography
                  //     style={{
                  //       paddingTop: "5%",
                  //       // paddingBottom: "5%",
                  //       // fontWeight: 400,
                  //       color: "orange",
                  //       textAlign: "left",
                  //     }}
                  //     variant="subtitle2"
                  //   >
                  //     Per {1 - this.props.product.stock1} pezzi il tempo di arrivo sarà
                  //     {(this.props.product.arrivingQuantityDate !== ""
                  //       ? dayjs(
                  //         this.props.product.arrivingQuantityDate,
                  //         "YYYY-MM-DD"
                  //       ).isSame(dayjs()) ||
                  //         dayjs(
                  //           this.props.product.arrivingQuantityDate,
                  //           "YYYY-MM-DD"
                  //         ).isBefore(dayjs())
                  //         ? " durante la giornata odierna"
                  //         : " al " +
                  //         dayjs(
                  //           this.props.product.arrivingQuantityDate,
                  //           "YYYY-MM-DD"
                  //         ).format("DD/MM/YYYY")
                  //       : "")}.
                  //   </Typography> :
                  this.props.product.arrivingQuantity > 0 && (1 > this.props.product.arrivingQuantity + this.props.product.stock1) ?
                    <Typography
                      style={{
                        // paddingTop: "5%",
                        // paddingBottom: "5%",
                        // fontWeight: 400,
                        color: "orange",
                        // textAlign: "left",
                      }}
                      variant="subtitle2"
                    >
                      {1 - this.props.product.arrivingQuantity - this.props.product.stock1} pezzi sono da ordinare
                      <Tooltip title="Contatta il commerciale per chiedere i tempi di consegna della merce contrassegnata da ‘ordinare">
                        <InfoIcon
                          fontSize="medium"
                          style={{
                            cursor: "pointer",
                            color: "#990617",
                            verticalAlign: "middle", // 🔥 allineamento
                            marginLeft: 4,
                          }}
                        />
                      </Tooltip>
                      {/* {(this.props.product.arrivingQuantityDate !== ""
                          ? dayjs(
                            this.props.product.arrivingQuantityDate,
                            "YYYY-MM-DD"
                          ).isSame(dayjs()) ||
                            dayjs(
                              this.props.product.arrivingQuantityDate,
                              "YYYY-MM-DD"
                            ).isBefore(dayjs())
                            ? " dopo la giornata odierna"
                            : " dopo il " +
                            dayjs(
                              this.props.product.arrivingQuantityDate,
                              "YYYY-MM-DD"
                            ).format("DD/MM/YYYY")
                          : "")}. */}
                    </Typography> :
                    this.props.product.stock1 > 0 && 1 > this.props.product.stock1 &&
                    <Typography
                      style={{
                        // paddingTop: "5%",
                        // paddingBottom: "5%",
                        // fontWeight: 400,
                        color: "orange",
                        // textAlign: "left",
                      }}
                      variant="subtitle2"
                    >
                      {1 - this.props.product.stock1} pezzi sono da ordinare
                      <Tooltip title="Contatta il commerciale per chiedere i tempi di consegna della merce contrassegnata da ‘ordinare">
                        <InfoIcon
                          fontSize="medium"
                          style={{
                            cursor: "pointer",
                            color: "#990617",
                            verticalAlign: "middle", // 🔥 allineamento
                            marginLeft: 4,
                          }}
                        />
                      </Tooltip>
                    </Typography>}
                {!this.props.product.configurable ? (
                  <AddToCartSmallBtn
                    onPress={this.addToCart}
                    loading={this.state.loading}
                    disabled={
                      // this.props.product.stock1 <= 0 ||
                      !this.props.isLogged ||
                      this.props.product.price <= 0
                    }
                    color={this.getAddToCartBtnColor()}
                  />
                ) : (
                  <Link to={this.props.linkName}>
                    <Button
                      variant={"contained"}
                      style={{ color: "white", backgroundColor: "#00c5fc" }}
                      disabled={this.state.loading}
                      startIcon={<BuildIcon />}
                    >
                      Vai alla Configurazione
                    </Button>
                  </Link>
                )}
              </div>
            </Grid>
          </Grid>
        </div>
        <Snackbar
          autoHideDuration={10000}
          open={this.state.openSnackBar}
          onClose={() => this.setState({ openSnackBar: false })}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          style={{ marginTop: "5%" }}
        >
          <Alert
            variant={"filled"}
            onClose={() => this.setState({ openSnackBar: false })}
            severity="success"
            action={
              <div>
                <Link to={"/carrello"}>
                  <Button color="inherit" size="small">
                    Visualizza Carrello
                  </Button>
                </Link>
                <IconButton
                  onClick={() => this.setState({ openSnackBar: false })}
                  color="inherit"
                  size="small"
                >
                  <Close />
                </IconButton>
              </div>
            }
          >
            Prodotto aggiunto al carrello!
          </Alert>
        </Snackbar>
        <Snackbar style={{ marginTop: "5%" }} anchorOrigin={{ vertical: "top", horizontal: 'center' }} open={this.state.errorDialog} autoHideDuration={6000} onClose={() => { this.setState({ errorDialog: false }) }}>
          <Alert variant={"filled"} onClose={() => { this.setState({ errorDialog: false }) }} severity="error">
            <h3 style={{ margin: 0, textAlign: "left" }}>Aggiunta non possibile</h3>
            <h4 style={{ margin: 0, textAlign: "left", fontWeight: "normal" }}>Quantità massima raggiunta per i seguenti prodotti:</h4>
            {this.state.productsError.map((item) => {
              return (<div style={{ textAlign: "left" }} key={item.id}>
                <span style={{ fontSize: "14px", padding: 0 }} >{item.productName}</span>
              </div>);
            })}
          </Alert>
        </Snackbar>
      </div>
    );
  }

  handleCloseSnack = () => {
    this.setState({
      openSnackBar: false,
    });
  };

  addToCart = () => {
    this.setState({
      loading: true,
    });
    let newCartItem = new CartItem();
    newCartItem.productId = this.props.product.id;
    newCartItem.quantity = 1;
    CartHandler.addItemToCart(newCartItem)
      .then(() => {
        this.setState({
          openSnackBar: true,
          loading: false,
        });
      })
      .catch((err) => {
        if (Array.isArray(err.response.data)) {
          this.setState({
            errorDialog: true,
            productsError: err.response.data,
            loading: false,
          })
        }
      });
  };

  getAddToCartBtnColor = (): string => {
    if (this.props.product.stock1 === 0 && this.props.product.arrivingQuantity === 0) {
      return "red";
    } else if (this.props.product.arrivingQuantity > 0 && (1 > this.props.product.stock1) && (1 <= this.props.product.arrivingQuantity + this.props.product.stock1)) {
      return "orange";
    } else if (this.props.product.arrivingQuantity > 0 && (1 > this.props.product.arrivingQuantity + this.props.product.stock1)) {
      return "orange";
    } else if (this.props.product.stock1 > 0 && 1 > this.props.product.stock1) {
      return "orange";
    } else {
      return "#b3071b";
    }
  };
}
